"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketLogProvider = void 0;
class WebSocketLogProvider {
    constructor(connection, address, commitment) {
        this.connection = connection;
        this.address = address;
        this.commitment = commitment;
    }
    subscribe(callback) {
        if (this.subscriptionId) {
            return true;
        }
        this.subscriptionId = this.connection.onLogs(this.address, (logs, ctx) => {
            callback(logs.signature, ctx.slot, logs.logs, undefined);
        }, this.commitment);
        return true;
    }
    isSubscribed() {
        return this.subscriptionId !== undefined;
    }
    async unsubscribe() {
        if (this.subscriptionId !== undefined) {
            await this.connection.removeOnLogsListener(this.subscriptionId);
            this.subscriptionId = undefined;
        }
        return true;
    }
}
exports.WebSocketLogProvider = WebSocketLogProvider;
